













import { computed, defineComponent } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import { storeToRefs } from 'pinia'

import { useProductStore } from '~/store/product'
import { useCMSGlobalSettingsStore } from '~/store/cms'

import { PRODUCT_STATUS, PRODUCT_TYPES } from '@/common/utils/product/constants'
import { DEVKEY } from '@/common/constants/cms'
import ContentTargeter from '~/components/global/targeters/ContentTargeter.vue'
import { useEbsStore } from '~/store/ebs'

export default defineComponent({
  components: {
    ContentTargeter,
  },
  setup() {
    const { currentProduct } = useProductStore()
    const { showGOPAvailability } = storeToRefs(useEbsStore())
    const { getAttributeByCountry } = useCMSGlobalSettingsStore()

    const mtoProductList = getAttributeByCountry('mtoProductList')?.value

    const productStatus = currentProduct.data.attributes.statusDates.status
    const orderingDetails = computed(() => {
      const assemblyOptionCode = Object.values(currentProduct.data.skuData)[0]?.attributes?.assemblyOptionCode

      if (!showGOPAvailability.value) {
        return currentProduct.data.attributes.orderingDetails
      }

      // when product type ELISA KIT and assemblyOptionCode PTO/MTO, then it should have custom hardcoded message
      if (
        currentProduct.data.productType === PRODUCT_TYPES.ELISA_KIT &&
        (assemblyOptionCode === 'PTO' ||
          assemblyOptionCode === 'MTO' ||
          mtoProductList?.includes(assemblyOptionCode as string))
      ) {
        return '<p>Looking for this ELISA kit in a <strong>384-well format</strong>? <a href="/learn-and-support/order-support?#sales-inquiry">Inquire</a> for availability, processing time, and pricing.</p>'
      }

      // remove ordering text for ATS/ATO/MTO assemblyOptionCode
      if (assemblyOptionCode === 'ATS' || assemblyOptionCode === 'ATO' || assemblyOptionCode === 'MTO') {
        return ''
      }

      return currentProduct.data.attributes.orderingDetails
    })

    const isProductDiscontinued = productStatus === PRODUCT_STATUS.DISCONTINUED
    const orderingDetailsRenderingCondition = !isEmpty(orderingDetails.value) && !isProductDiscontinued

    return {
      isProductDiscontinued,
      orderingDetails,
      orderingDetailsRenderingCondition,
      isEmpty,
      DEVKEY,
    }
  },
})
